import { useMemo } from 'react';
import { Box, IconButton, Typography } from '@mui/material';
import HomeIcon from '@mui/icons-material/Home';
import { useNavigate } from 'react-router-dom';
import DynamicBreadcrumbs from '../../../components/Shared/Breadcrumb/index.tsx';
import { FeatureThemeProvider } from '../../../theme/FeatureThemeProvider.jsx';
import useTemplateSx from '../hooks/useTemplateSx';
import OptinUsersPanel from '../components/list/OptinUsersPanel';
import { TEMPLATE_BASE_PATH } from '../constants/templateApi';

export default function OptinUsersPage() {
  return (
    <FeatureThemeProvider>
      <OptinUsersPageContent />
    </FeatureThemeProvider>
  );
}

function OptinUsersPageContent() {
  const styles = useTemplateSx();
  const navigate = useNavigate();

  const breadcrumbsData = useMemo(
    () => [
      { label: <IconButton color="primary"><HomeIcon /></IconButton>, href: '/' },
      { label: 'Templates', href: `${TEMPLATE_BASE_PATH}/template-list` },
      { label: 'Optin Users' },
    ],
    []
  );

  return (
    <Box sx={styles.pageRoot}>
      <DynamicBreadcrumbs
        items={breadcrumbsData}
        onBreadcrumbClick={(_event, item) => {
          if (item?.href) navigate(item.href);
        }}
      />

      <Box sx={styles.pageHeader}>
        <Box>
          <Typography variant="h5" sx={styles.pageTitle}>
            Optin Users
          </Typography>
          <Typography variant="body2" sx={styles.pageSubtitle}>
            Users who opted in to receive WhatsApp messages
          </Typography>
        </Box>
      </Box>

      <Box sx={styles.dashboardSurface}>
        <OptinUsersPanel />
      </Box>
    </Box>
  );
}
